import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const PositionChart = ({ attendees }) => {
  const chartRef = useRef();
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    // Calculate positions with counts
    const positions = {};
    attendees.forEach((attendee) => {
      positions[attendee.position] = (positions[attendee.position] || 0) + 1;
    });

    // Convert positions object to sorted arrays (descending order)
    const sortedLabels = Object.keys(positions).sort((a, b) => positions[b] - positions[a]);
    const sortedData = sortedLabels.map((label) => positions[label]);

    const barColors = ["orange", "brown", "black", "red", "green", "blue"];

    const ctx = chartRef.current.getContext('2d');

    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: sortedLabels,
        datasets: [
          {
            data: sortedData,
            backgroundColor: barColors.slice(0, sortedLabels.length), // Ensure colors match dataset length
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false }, // Hide legend if not needed
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [attendees]);

  return <canvas ref={chartRef} />;
};

export default PositionChart;
